import { Typography } from "@material-ui/core"

const Style = (props) => {

  return ( <>
    <Typography>
    Absolutely! Whether you want a romantic acoustic ballad, an upbeat pop anthem, a country tearjerker, or even a ska-punk jam (because why not?), we’ve got you covered. Just let us know your preferred style during the lyricist chat, and we’ll make sure your song sounds exactly how you imagine.
    </Typography>
  </> )
}

export default Style
